import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, apiError } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=loading, false=anon, obj=user
    const [error, setError] = useState("");

    const bootstrap = useCallback(async () => {
        const token = localStorage.getItem("fx_token");
        if (!token) {
            setUser(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("fx_token");
            setUser(false);
        }
    }, []);

    useEffect(() => {
        bootstrap();
    }, [bootstrap]);

    async function login(email, password) {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("fx_token", data.access_token);
            setUser(data.user);
            return { ok: true, user: data.user };
        } catch (e) {
            const msg = apiError(e, "Login failed");
            setError(msg);
            return { ok: false, error: msg };
        }
    }

    function logout() {
        localStorage.removeItem("fx_token");
        setUser(false);
    }

    async function refreshMe() {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {}
    }

    return (
        <AuthCtx.Provider value={{ user, error, login, logout, refreshMe }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
